var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9608 3.22998H14.04V21.0505H23.9608V3.22998Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.67 12.1404C14.6684 10.4242 15.0575 8.73009 15.8077 7.18638C16.558 5.64266 17.6498 4.28979 19.0004 3.2302C17.3278 1.91605 15.3191 1.0988 13.2038 0.871857C11.0885 0.644916 8.95201 1.01743 7.03851 1.94684C5.12501 2.87626 3.5117 4.32506 2.38301 6.12765C1.25431 7.93024 0.655762 10.0139 0.655762 12.1404C0.655762 14.267 1.25431 16.3506 2.38301 18.1532C3.5117 19.9558 5.12501 21.4046 7.03851 22.334C8.95201 23.2635 11.0885 23.636 13.2038 23.409C15.3191 23.1821 17.3278 22.3648 19.0004 21.0507C17.6498 19.9911 16.558 18.6382 15.8077 17.0945C15.0575 15.5508 14.6684 13.8567 14.67 12.1404Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3446 12.1404C37.3447 14.267 36.7462 16.3506 35.6175 18.1532C34.4889 19.9558 32.8757 21.4046 30.9622 22.334C29.0487 23.2634 26.9123 23.636 24.797 23.409C22.6818 23.1821 20.673 22.3648 19.0005 21.0507C20.35 19.99 21.4409 18.6369 22.191 17.0935C22.9412 15.55 23.3309 13.8564 23.3309 12.1404C23.3309 10.4245 22.9412 8.7309 22.191 7.18742C21.4409 5.64395 20.35 4.29086 19.0005 3.23019C20.673 1.91604 22.6818 1.09879 24.797 0.871854C26.9123 0.644915 29.0487 1.01745 30.9622 1.94687C32.8757 2.87629 34.4889 4.3251 35.6175 6.12769C36.7462 7.93028 37.3447 10.0139 37.3446 12.1404Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2628 19.163V18.7982H36.41V18.7239H36.0352V18.7982H36.1824V19.163H36.2628ZM36.9905 19.163V18.7231H36.8756L36.7434 19.0257L36.6113 18.7231H36.4963V19.163H36.5774V18.8312L36.7014 19.1173H36.7855L36.9094 18.8305V19.163H36.9905Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.911867b668d6439affd650bcb1ca1e25.svg";
export { ForwardRef as ReactComponent };